module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/img/cloud-housing.56d2f3d1.svg";